export default __webpack_public_path__ + "static/media/noDocumentValidation.893b8617.svg";